<template>
  <div id="admin-system-tag" v-loading="loading">
    <!-- 标签 -->
    <div class="left">
      <div class="top">
        <el-input
          v-model="searchTag"
          placeholder="可输入关键字搜索标签"
          suffix-icon="el-icon-search"
          @keyup.enter.native="getAllTag"
        ></el-input>
      </div>
      <div class="list">
        <div
          :class="{ item: true, 'active-item': tempTag.name == item.name }"
          v-for="(item, index) in tipList"
          :key="index"
          @click="changeTag(item)"
        >
          {{ item.name }}
          <el-dropdown>
            <i class="iconfont icon-androidgengduo"></i>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(it, ii) in tipOper" :key="ii"
                ><span @click.stop="clickMore(item, it.key)">{{
                  it.title
                }}</span></el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="add_but" @click="addTag">
          <i class="el-icon-plus"></i> 添加标签
        </div>
      </div>
    </div>
    <div class="right">
      <div class="add-tag" v-if="tempTag.name == ''">
        <!-- 一个标签没有 -->
        <div class="add_but" @click="addTag">
          <i class="el-icon-plus"></i>添加标签
        </div>
      </div>
      <div class="show-tag" v-else>
        <div class="top">{{ tempTag.name }}</div>
        <div class="line">
          <div class="title">系统成员:</div>
          <div class="value">
            <div class="but">
              <span @click="openChooseUserForTag">
                <!-- <span @click="openChooseUserForTag" v-if="chooseUser"> -->
                选择成员</span
              >
              <el-tooltip
                class="item"
                effect="dark"
                content="当前选择的学员将拥有该标签所设的权限,同一用户可拥有多个标签,权限进行叠加!"
                placement="bottom-start"
              >
                <i class="el-icon-question"></i>
              </el-tooltip>
            </div>
            <div class="val">
              <div
                class="item"
                v-for="(user, index) in tipUserList"
                :key="index"
              >
                {{ user.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="line">
          <div class="title">相关权限:</div>
          <div class="value">
            <div class="check-all">
              <el-checkbox v-model="checkAll" @change="checkAllAuth"
                >全选</el-checkbox
              >

              <!-- <div class="but" @click="submit" v-if="chooseAuth"> -->
              <div class="but" @click="submit">
                <i class="el-icon-check"></i>提交
              </div>
            </div>
            <div class="auth-list">
              <div class="auth-father">
                <div
                  :class="{
                    'auth-fa': true,
                    'is-active-auth': tempAuth.corKey == item.corKey,
                  }"
                  v-for="(item, index) in authList"
                  :key="index"
                  @click="changeTempAuth(item, index)"
                >
                  <el-checkbox
                    v-model="item.purview"
                    @change="changeFatherAuth(item)"
                  ></el-checkbox
                  ><span style="margin-left: 8px">{{ item.name }}</span>
                </div>
              </div>
              <div class="auth-right">
                <div
                  class="auth-child"
                  v-for="(modelAuth, index) in tempAuth.children"
                  :key="index"
                >
                  <div class="title">
                    <el-checkbox
                      v-model="modelAuth.purview"
                      :disabled="!tempAuth.purview"
                      @change="changeChilderAuth(modelAuth)"
                      >{{ modelAuth.name }}</el-checkbox
                    >
                  </div>
                  <div class="auth">
                    <div
                      class="feature"
                      v-for="(feature, ii) in modelAuth.children"
                      :key="ii"
                    >
                      <el-checkbox
                        v-model="feature.purview"
                        :disabled="!modelAuth.purview || !tempAuth.purview"
                        @change="changetishianniu"
                        >{{ feature.name }}</el-checkbox
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 选择人员的弹出框 -->
    <div class="user-dialog" @click="colseUserDialog" v-if="userDialog.flag">
      <div class="content" @click.stop="clickNull">
        <div class="colse" @click="colseUserDialog">
          <i class="el-icon-close"></i>
        </div>
        <div class="title">选择学员</div>
        <div class="dd">
          <div class="left">
            <div class="search">
              <el-input
                v-model="userDialog.search"
                placeholder="可输入关键字搜索学员"
                clearable
              ></el-input>
            </div>
            <dep_user_tree
              :treeData="userDialog.treeData"
              :checkData="userDialog.userData"
              @handleCheckChange="handleCheckChange"
            ></dep_user_tree>
          </div>
        </div>
        <div class="buts">
          <div class="but" @click="setUserAuthority">确定</div>
          <div class="but" @click="colseUserDialog">取消</div>
        </div>
      </div>
    </div>

    <diy_dialog
      v-if="dialogData.flag"
      :title="dialogData.title"
      :width="dialogData.width"
      :dialogData="dialogData.dialogData"
      :buttonList="dialogData.buttonList"
      @colseDialog="colseDialog"
      @dialogOper="dialogOper"
    ></diy_dialog>
  </div>
</template>

<script>
import * as tipData from "./tag.js";
import * as base from "../../js/base.js";
export default {
  data() {
    return {
      loading: false,
      searchTag: "", // 标签搜索
      tipList: [
        // 标签列表
        { id: "", name: "标签一" },
        { id: "", name: "标签二" },
      ],
      tipOper: [
        // 标签的操作数组
        { title: "编辑标签", key: "edit" },
        { title: "添加标签", key: "add" },
        { title: "删除标签", key: "delete" },
      ],
      tempTag: { id: "", name: "标签一" },
      tipUserList: [
        // 拥有该标签的用户信息
        { id: "", name: "张三" },
        { id: "", name: "李四" },
        { id: "", name: "王五" },
      ],
      checkAll: false, // 是否权限全选
      authList: tipData.processorAuthorityData(tipData.getAuthorityDataInit()),
      tempAuth: {}, // 临时编辑的权限列表
      userDialog: {
        // 选择人员的弹出框
        flag: false,
        search: "", // 部门/学员树中,根据学员名称模糊匹配学员树
        treeData: [],
        userData: [],
        userList: [],
      },
      dialogData: {
        flag: false,
        title: "添加子部门",
        width: "50%",
        tempData: {},
        dialogData: [],
        buttonList: [
          { text: "确定", active: "makesure_add_child_dep" },
          { text: "取消", active: "cancel" },
        ],
      },

      chooseUser: true, // 是否可选择成员
      chooseAuth: true, // 是否可提交权限
      tempIndex: 0,
    };
  },
  methods: {
    // 权限设置  获取设置标签界面所有子界面的权限  标签设置 6
    async getUsersAllAuthorityByModel() {
      try {
        let resultData = await this.$request({
          url: "/authority/getUsersAllAuthorityByModel",
          method: "post",
          data: { feature: "6" },
        });
        this.tipOper = base.returnAllButton(this.tipOper, resultData, "title");

        this.chooseUser = resultData.includes("选择成员");
        this.chooseAuth = resultData.includes("编辑权限");
      } catch (error) {}
    },
    /**
     * 获取所有标签
     */
    async getAllTag() {
      try {
        this.loading = true;
        let requestData = {
          name: this.searchTag,
        };
        let resultData = await this.$request({
          url: "/tag/getAllTagList",
          method: "post",
          data: requestData,
        });
        this.tipList = resultData;
        if (this.tipList.length > 0) {
          await this.changeTag(this.tipList[0]);
        } else {
          this.tempTag = {
            name: "",
          };
        }
        this.loading = false;
      } catch (error) {
        this.$message.error(error.message);
        this.loading = false;
      }
    },
    /**
     * 点击标签的更多
     */
    async clickMore(tag, active) {
      console.log("点击标签的其他操作", tag);
      this.dialogData.tempData = tag;
      switch (active) {
        case "edit":
          try {
            if (tag.id == "0" || tag.id == 0) {
              throw { message: "系统标签不可编辑!!!" };
            }
            this.dialogData.title = "编辑标签";
            this.dialogData.width = "30%";
            this.dialogData.dialogData = [
              {
                title: "标签名称",
                value: tag.name,
                type: "input",
                key: "name",
              },
            ];
            this.dialogData.buttonList = [
              { text: "确定", active: "makesure_add_tip" },
              { text: "取消", active: "cancel" },
            ];
            this.dialogData.flag = true;
          } catch (error) {
            this.$message.error(error.message);
          }
          break;
        case "add":
          // 添加标签
          this.addTag();
          break;
        case "delete":
          // 删除标签
          try {
            if (tag.id == "0" || tag.id == 0) {
              throw { message: "系统标签不可删除!!!" };
            }
            this.$confirm(
              "删除标签的同时,会清除掉当前标签下所有用的相关权限, 是否继续?",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            )
              .then(async () => {
                let resultData = await this.$request({
                  url: "/tag/deleteTag",
                  method: "post",
                  data: { id: tag.id },
                });
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                await this.getAllTag();
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消删除",
                });
              });
          } catch (error) {
            this.$message.error(error.message);
          }
          break;

        default:
          break;
      }
    },
    /**
     * 点击标签,查看详情
     */
    async changeTag(tag) {
      this.tempTag = JSON.parse(JSON.stringify(tag));
      this.tempIndex = 0;
      await this.getAuthorityByTag();
    },
    /**
     * 获取当前标签的所有权限
     */
    async getAuthorityByTag() {
      try {
        this.loading = true;
        let resultData = await this.$request({
          url: "/authority/getAuthorityByTag",
          method: "post",
          data: { tagId: this.tempTag.id },
        });
        this.tipUserList = resultData.userList;
        this.authList = tipData.processorAuthorityData(resultData.authority);
        this.tempIndex = 0;
        this.tempAuth = this.authList[this.tempIndex];
        this.loading = false;
      } catch (error) {
        this.$message.error(error.message);
        this.loading = false;
      }
    },
    /**
     * 添加标签
     */
    addTag() {
      this.dialogData.tempData = { id: "" };
      this.dialogData.title = "添加标签";
      this.dialogData.width = "30%";
      this.dialogData.dialogData = [
        { title: "标签名称", value: "", type: "input", key: "name" },
      ];
      this.dialogData.buttonList = [
        { text: "确定", active: "makesure_add_tip" },
        { text: "取消", active: "cancel" },
      ];
      this.dialogData.flag = true;
    },
    /**
     * 打开选择学员弹出框
     * 1.弹出框打开
     * 2.将当前已有学员显示在界面
     */
    async openChooseUserForTag() {
      try {
        if (this.tempTag.id == "0" || this.tempTag.id == 0) {
          throw { message: "系统标签不可添加成员!!!" };
        }
        let resultData = await this.$request({
          url: "/department/getDepartmentUserTree",
          method: "post",
          data: {},
        });
        this.userDialog.treeData = [resultData];
        this.userDialog.userList = JSON.parse(JSON.stringify(this.tipUserList));
        this.userDialog.userData = [];
        this.userDialog.userList.forEach((element) => {
          this.userDialog.userData.push(element.userId);
        });
        this.userDialog.flag = true;
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 选择学员
     */
    handleCheckChange(val) {
      console.log("父组件接受的值:", val.checkedNodes);
      let list = [];
      val.checkedNodes.forEach((element) => {
        if (!element.children) {
          list.push(element);
        }
      });
      this.userDialog.userList = list;
    },
    /**
     * 设置标签下用户组
     */
    async setUserAuthority() {
      try {
        console.log(this.userDialog);
        let userIds = [];
        this.userDialog.userList.forEach((element) => {
          userIds.push(element.id);
        });
        let requestData = {
          tagId: this.tempTag.id,
          userIds: userIds,
        };
        let resultData = await this.$request({
          url: "/authority/setUserAuthority",
          method: "post",
          data: requestData,
        });
        this.changeTag(this.tempTag);
        this.userDialog.flag = false;
        this.$message({
          message: "操作成功!",
          type: "success",
        });
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 切换一级模块功能
     */
    async changeTempAuth(item, index) {
      this.authList[this.tempIndex] = await JSON.parse(
        JSON.stringify(this.tempAuth)
      );
      this.tempAuth = item;
      this.tempIndex = index;
    },
    /**
     * 一级模块权限选择事件
     */
    changeFatherAuth(item) {
      if (!item.purview) {
        this.checkAll = false;
        // 去掉权限  将底下所有子模块及其功能权限全部去掉
        for (let index = 0; index < item.children.length; index++) {
          const element = item.children[index];
          element.purview = false;
          this.changeChilderAuth(element);
        }
      }
    },
    /**
     * 二级模块权限选择事件
     */
    changeChilderAuth(item) {
      if (!item.purview) {
        this.checkAll = false;
        // 去掉权限  将底下所有功能权限全部去掉
        for (let index = 0; index < item.children.length; index++) {
          const element = item.children[index];
          element.purview = false;
        }
      }
    },
    /**
     * 所有权限全选
     */
    checkAllAuth() {
      if (this.checkAll) {
        this.authList = tipData.checkAuthorityData(this.authList);
      }
    },
    /**
     * 修改功能时,改变"全选"按钮显示状态
     */
    changetishianniu(el) {
      console.log("所有权限", this.authList, this.tempAuth);
      if (!el) {
        this.checkAll = false;
      }
    },
    /**
     * 提交权限
     */
    async submit() {
      try {
        if (this.tempTag.id == "0" || this.tempTag.id == 0) {
          throw { message: "系统标签不可编辑权限!!!" };
        }
        this.authList[this.tempIndex] = await JSON.parse(
          JSON.stringify(this.tempAuth)
        );
        console.log(this.authList);
        this.$forceUpdate();
        let requestData = {
          tagId: this.tempTag.id,
          authority: tipData.processorAuthorityDataForInterface(
            JSON.parse(JSON.stringify(this.authList))
          ),
        };
        console.log(requestData);
        let resultData = await this.$request({
          url: "/authority/saveAuthorityByTag",
          method: "post",
          data: requestData,
        });
        this.changeTag(this.tempTag);
        this.$message({
          message: "操作成功!",
          type: "success",
        });
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 弹出框操作事件
     */
    async dialogOper(active) {
      try {
        let requestData = {};
        let resultData = {};
        switch (active) {
          case "makesure_add_tip":
            // 确定添加/编辑标签
            requestData = {
              id: this.dialogData.tempData.id,
            };
            requestData = this.$baseData.array2json(
              this.dialogData.dialogData,
              requestData
            );
            if (requestData.name == "") {
              throw { message: "标签名称不可为空!" };
            }
            resultData = await this.$request({
              url: "/tag/saveOrUpdateTag",
              method: "post",
              data: requestData,
            });
            this.dialogData.flag = false;
            await this.getAllTag();
            break;
          case "cancel":
            this.colseDialog();
            break;

          default:
            break;
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 关闭选择学员弹出框
     */
    colseUserDialog() {
      this.userDialog.flag = false;
    },
    /**
     * 阻止点击弹出框的内容界面是,时间穿透至底下关闭弹窗事件
     */
    clickNull() {},
    colseDialog() {
      this.dialogData.flag = false;
    },
  },
  async mounted() {
    await this.getUsersAllAuthorityByModel();
    await this.getAllTag();
    this.tempAuth = this.authList[0];
  },
};
</script>

<style lang="less" scoped>
#admin-system-tag {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 10px 15px;
  box-sizing: border-box;
  > .left {
    width: 300px;
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    // overflow-y: auto;
    padding: 10px;
    box-sizing: border-box;
    > .top {
      width: 100%;
      height: 40px;
      display: flex;
      justify-content: center;
    }
    > .list {
      width: 100%;
      height: 0;
      flex: 1;
      overflow-y: auto;
      margin-top: 15px;
      display: flex;
      flex-direction: column;
      > .item {
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        padding: 0 10px;
        box-sizing: border-box;
        font-size: 15px;
        transition: 0.3s;
        &:hover {
          background-color: #f5f5f5;
        }
      }
      > .active-item {
        background-color: #f5f5f5;
      }
    }
  }
  > .right {
    width: 0;
    flex: 1;
    height: 100%;
    margin-left: 15px;
    background-color: #fff;
    display: flex;
    padding: 10px;
    box-sizing: border-box;
    align-items: center;
    justify-content: center;
    > .add-tag {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    > .show-tag {
      width: 100%;
      height: 100%;
      overflow-y: auto;
      display: flex;
      flex-direction: column;
      overflow-y: auto;
      > .top {
        width: auto;
        height: 25px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding-left: 10px;
        border-left: 5px double #333;
        box-sizing: border-box;
        font-size: 15px;
        font-weight: bold;
        margin-left: 20px;
      }
      > .line {
        width: 100%;
        height: auto;
        display: flex;
        margin-top: 20px;
        background-color: #f0f0f0;
        padding-top: 10px;
        box-sizing: border-box;
        > .title {
          width: 150px;
          height: 100%;
          display: flex;
          align-items: flex-start;
          justify-content: flex-end;
          margin-right: 10px;
          font-size: 15px;
          font-weight: bold;
        }
        > .value {
          width: 0;
          flex: 1;
          height: auto;
          display: flex;
          flex-direction: column;
          > .but {
            width: 100%;
            height: 40px;
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            font-size: 15px;
            > span {
              width: auto;
              height: auto;
              box-sizing: border-box;
              color: #117bd1;
              cursor: pointer;
              transition: 0.3s;
              &:hover {
                color: #559beb;
                text-decoration: underline;
                text-underline-offset: 5px;
              }
            }
            > i {
              margin-left: 8px;
              cursor: pointer;
              // color: #e46116;
              font-size: 18px;
            }
          }
          > .val {
            width: 100%;
            height: auto;
            display: flex;
            flex-wrap: wrap;
            > .item {
              width: auto;
              height: auto;
              padding: 0 10px;
              color: #117bd1;
              margin-bottom: 10px;
              font-size: 15px;
              border: 1px solid #117bd1;
              border-radius: 3px;
              box-sizing: border-box;
              margin-right: 10px;
            }
          }
          > .check-all {
            width: 100%;
            height: auto;
            display: flex;
            > .but {
              margin-left: 30px;
              width: auto;
              height: auto;
              padding: 1px 38px;
              box-sizing: border-box;
              border: 1px solid #dd5110;
              font-size: 14px;
              border-radius: 3px;
              color: #dd5110;
              cursor: pointer;
              transition: 0.3s;
              &:hover {
                background-color: #dd5110;
                color: #fff;
              }
              > i {
                margin-right: 5px;
              }
            }
          }
          > .auth-list {
            width: 98%;
            // height: auto;
            background-color: #fff;
            margin-top: 10px;
            margin-bottom: 10px;
            display: flex;
            margin-right: 10px;
            box-sizing: border-box;
            > .auth-father {
              width: 180px;
              height: auto;
              display: flex;
              flex-direction: column;
              line-height: 50px;
              margin: 10px;
              box-sizing: border-box;
              > .auth-fa {
                width: 100%;
                height: 70px;
                display: flex;
                align-items: center;
                margin-left: 10px;
                border: 1px solid #dddddd;
                padding-left: 10px;
                box-sizing: border-box;
                border-top: none;
                font-size: 13px;
                cursor: pointer;
                &:nth-child(1) {
                  border-top: 1px solid #dddddd;
                }
              }
              > .is-active-auth {
                border-right: none;
              }
            }
            > .auth-right {
              width: 0;
              flex: 1;
              height: auto;
              display: flex;
              flex-direction: column;
              margin: 10px;
              > .auth-child {
                margin-bottom: 10px;
                width: 100%;
                // height: auto;
                display: flex;
                flex-direction: column;
                border: 1px solid #dddddd;
                > .title {
                  width: 100%;
                  height: 40px;
                  background-color: #edf6fd;
                  display: flex;
                  align-items: center;
                  padding-left: 20px;
                  border-bottom: 1px solid #dddddd;
                  box-sizing: border-box;
                }
                > .auth {
                  width: 100%;
                  height: auto;
                  line-height: 35px;
                  display: flex;
                  flex-wrap: wrap;
                  padding: 0 20px;
                  box-sizing: border-box;
                  > .feature {
                    margin: 10px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  > .user-dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: #00000036;
    z-index: 99;
    display: flex;
    justify-content: center;
    > .content {
      width: 35%;
      height: 800px;
      background-color: #fff;
      margin-top: 100px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
      border-radius: 10px;
      position: relative;
      padding: 20px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      > .colse {
        position: absolute;
        right: 20px;
        top: 20px;
        cursor: pointer;
      }
      > .title {
        width: 100%;
        padding-left: 20px;
        border-left: 5px double #333;
        box-sizing: border-box;
        display: flex;
        font-weight: bold;
      }
      > .dd {
        width: 100%;
        height: 0;
        flex: 1;
        display: flex;
        overflow-y: auto;
        > .left {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          overflow-y: auto;
          padding: 10px;
          box-sizing: border-box;
          > .search {
            width: 100%;
            height: 40px;
            display: flex;
          }
        }
      }
      > .buts {
        width: 100%;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        > .but {
          width: auto;
          height: auto;
          padding: 5px 50px;
          box-sizing: border-box;
          background-color: @baseColor;
          color: #fff;
          margin: 0 10px;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
          border-radius: 3px;
          cursor: pointer;
          &:nth-last-child(1) {
            background-color: #919191;
          }
        }
      }
    }
  }
}
</style>